import { render, staticRenderFns } from "./UiKit.vue?vue&type=template&id=8394713a&scoped=true"
import script from "./UiKit.vue?vue&type=script&lang=ts"
export * from "./UiKit.vue?vue&type=script&lang=ts"
import style0 from "./UiKit.vue?vue&type=style&index=0&id=8394713a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8394713a",
  null
  
)

export default component.exports